import React from 'react';

// TODO: Mobile Banner will be implement with another job
const MobileMenu = () => {
  return <div>MobileMenu</div>;
};

export default MobileMenu;
